import { render, staticRenderFns } from "./VEmployeesBrowse.vue?vue&type=template&id=5b784f42&scoped=true&lang=pug"
import script from "./VEmployeesBrowse.vue?vue&type=script&lang=ts"
export * from "./VEmployeesBrowse.vue?vue&type=script&lang=ts"
import style0 from "./VEmployeesBrowse.vue?vue&type=style&index=0&id=5b784f42&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b784f42",
  null
  
)

export default component.exports